import * as React from "react";

function FilterSvg(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 1.75h11c.916 0 1.666.75 1.666 1.667V5.25c0 .667-.416 1.5-.833 1.917l-3.583 3.166c-.5.417-.834 1.25-.834 1.917v3.583c0 .5-.333 1.167-.75 1.417L10 18c-1.084.667-2.584-.083-2.584-1.417v-4.416c0-.584-.333-1.334-.666-1.75L3.583 7.083c-.417-.416-.75-1.166-.75-1.666V3.5c0-1 .75-1.75 1.667-1.75z"
        stroke="url(#paint0_linear_1450_3080)"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.108 1.75L5 8.333"
        stroke="url(#paint1_linear_1450_3080)"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1450_3080"
          x1={9.99967}
          y1={1.75}
          x2={9.99967}
          y2={18.2475}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1450_3080"
          x1={7.05417}
          y1={1.75}
          x2={7.05417}
          y2={8.33333}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#099D16" />
          <stop offset={1} stopColor="#006209" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default FilterSvg;
